import { Injectable, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Lista2Service } from './lista2.service';
import { WebSocketService } from './websocket.service';
import {
  FILTRO_EVENTOS_TECNICOS,
  ReconciliacionWs,
} from './ws-reconciliacion';
import { LoginService } from '../../modulos/login/login.service';

/**
 * Conteo global de servicios técnicos / verificaciones PENDIENTES (requieren
 * atención, no finalizados) para el badge del navigator. Mismo criterio que la
 * solapa "Pendientes" del listado. Sin sonido ni notificación.
 */
@Injectable({ providedIn: 'root' })
export class ServiciosTecnicosPendientesService {
  private lista2 = inject(Lista2Service);
  private wsService = inject(WebSocketService);

  // El mensaje es solo un trigger de refetch → modo 'trigger' (batcheado y
  // recortado) + filtro server-side por filtrador: este badge solo cuenta ST
  // y verificaciones.
  private reconciliacionWs = new ReconciliacionWs(this.wsService, {
    entidades: ['eventogenerico'],
    idPermiso: () => LoginService.getIdPermiso(),
    relistar: () => this.listar(),
    modo: 'trigger',
    filtro: FILTRO_EVENTOS_TECNICOS,
  });

  public totalCount = 0;
  private sub?: Subscription;

  private listar(): void {
    this.sub?.unsubscribe();
    const idUsuario = LoginService.getUsuario()?._id;
    const filter: Record<string, unknown> = {
      requiereAtencion: true,
      filtrador: { $in: ['Servicio Técnico', 'Verificación'] },
      // Mismo criterio de visibilidad por técnico que el listado.
      $or: [
        { 'detallesTecnicos.idTecnicoAsignado': { $exists: false } },
        { 'detallesTecnicos.idTecnicoAsignado': null },
        {
          'detallesTecnicos.idTecnicoAsignado': {
            $exists: true,
            $ne: idUsuario,
          },
        },
        {
          'detallesTecnicos.idTecnicoAsignado': idUsuario,
          $or: [
            {
              'detallesTecnicos.fechaDisponibleParaTratar': { $exists: false },
            },
            { 'detallesTecnicos.fechaDisponibleParaTratar': null },
            {
              'detallesTecnicos.fechaDisponibleParaTratar': {
                $lte: new Date().toISOString(),
              },
            },
          ],
        },
      ],
    };
    this.sub = this.lista2
      .eventosGenericos(
        { filter: JSON.stringify(filter), includeChildren: true, limit: 1 },
        this.reconciliacionWs.intervaloActual(),
      )
      .subscribe((res) => {
        this.totalCount = res.totalCount;
      });
  }

  public iniciarServicio(): void {
    this.reconciliacionWs.iniciar();
    this.listar();
  }

  public reiniciar(): void {
    this.sub?.unsubscribe();
    this.totalCount = 0;
    this.reconciliacionWs.iniciar();
    this.listar();
  }

  /**
   * Corta suscripción WS y polling. Lo usa el navigator cuando el permiso
   * activo no tiene el módulo de servicio técnico: sin esto, un usuario que
   * nunca ve el badge igual quedaba suscripto a `eventogenerico` y polleando.
   */
  public detener(): void {
    this.sub?.unsubscribe();
    this.sub = undefined;
    this.totalCount = 0;
    this.reconciliacionWs.detener();
  }
}
